document.addEventListener('DOMContentLoaded', function() {

  const detailsElements = document.querySelectorAll('details.accordion');

  detailsElements.forEach(detail => {
    detail.addEventListener('click', function() {
      detailsElements.forEach(d => {
        if (d !== detail) {
          d.removeAttribute('open');
          d.setAttribute('aria-expanded', 'false');
        }
      });

      if (detail.hasAttribute('open')) {
        detail.setAttribute('aria-expanded', 'true');
      } else {
        detail.setAttribute('aria-expanded', 'false');
      }
    });
  });
});